import React, { useState } from "react";
import "../forcss/hamburger.css"


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
// ! ive got the hamburger code from ai but before the burger everything was written by me,well who tf will be creating a burger while u have an ai to do that foru
  return (
    <header>
      <a href="/"><div className="logo">
        <img src="/logoo.svg" alt="logo" />
        IlyosDev
      </div></a>

      {/* Nav Links */}
      <nav className={`nav-links ${menuOpen ? "active" : ""}`}>
        <a href="/">About</a>
        <a href="/videos">Course Detail</a>
        <a href="/learn">Learn</a>
        <a href="/enroll"><button>Kursga yozilish</button></a>
      </nav>

      {/* Burger */}
      <div
        className={`burger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
  );
};

export default Header;